import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash;
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) { navigate("/admin/login"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        setUser(data.user);
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { replace: true });
      } catch {
        navigate("/admin/login", { replace: true });
      }
    })();
  }, []); // eslint-disable-line

  return (
    <div className="min-h-screen bg-forest flex items-center justify-center">
      <Loader2 className="animate-spin text-gold" size={40} />
    </div>
  );
}
